import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CheckIcon } from '../../../../assets/icons/check_purple_icon.svg';
import { getActions, navigateToView , getActionsVoucher} from "store/appTrack/actions";
import { useNavigate } from "react-router-dom";
import { claimActive, updateFormField } from "store/forms/actions";
import { isAuditor, isBeneficiary, isObjectionCommittee, isSupplier, isVoucherAuditor }  from 'utils';
import { Spin } from "antd";
import { assign } from "lodash";
import { returnToEvaluation } from "store/appTrack/actions";

const ActionList = (props) =>{
    //const view = useSelector(state => state.appTrack.permissions.view)
    const [isReady, setIsReady] = useState(false);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const privileges = useSelector(state => state.user.privileges);
    const view = useSelector(state => state.appTrack.permissions.view);
    const edit = useSelector(state => state.appTrack.permissions.edit);
    const cancel = useSelector(state => state.appTrack.permissions.cancel);
    const cancelAccepted = useSelector(state => state.appTrack.permissions.cancelAccepted); //permissions for applications in ACCEPTED STATUS
    const cancelServiceFromAccepted = useSelector(state => state.appTrack.permissions.cancelService); //permissions for applications in ACCEPTED STATUS
    const releaseEquipment = useSelector(state => state.appTrack.permissions.releaseEquipment);
    const releaseService = useSelector(state => state.appTrack.permissions.releaseService);
    const unassign = useSelector(state => state.appTrack.permissions.unassign);
    const assign = useSelector(state => state.appTrack.permissions.assign);
    const submitObjection = useSelector(state => state.appTrack.permissions.submitObjection);
    const groups = useSelector(state => state.user.groups);
    const variables = useSelector(state => state.appTrack.variables);
    const user = useSelector(state => state.user);
    
    const [cancelService, setCancelService] = useState(false);
    const [voucherEdit, setVoucherEdit] = useState(false);
    const [persmissionsTrue, setPersmissionsTrue] = useState(false);



useEffect(() => {
  if(!props?.voucherAuditor){
    if(props.voucherFlag){
      let mounted = true;

      const initializeActions = () => {
        dispatch(getActions(props.id))
          .then(() => {
            if (!mounted) return;
            
            if (typeof view !== 'undefined' && 
                typeof edit !== 'undefined' && 
                typeof cancel !== 'undefined') {
              setIsReady(true);
            }
          })
          .catch((error) => {
            if (!mounted) return;
            console.error('Failed to initialize actions:', error);
            setError(error);
          });
      };
    
      initializeActions();

      // cleanup to prevent mem leaks
      return () => {
        mounted = false;
      };
    } else {
      dispatch(getActionsVoucher(props.voucher, groups)) 
        .then(response => {
          const resonse1 = {
            "reserve": false,
            "redeem": false,
            "release": false,
            "redeemOverwrite": false
          }

          const persmissionsTrue = Object.values(response).some(value => value === true);
          setPersmissionsTrue(persmissionsTrue);
          setVoucherEdit(true);
          setIsReady(true);
        })
        .catch((error) => {
          console.error('Failed to initialize actions:', error);
          setError(error);
        });
    }
  } else {
    setIsReady(true);
  }
}, [
  dispatch,
  props.id,
  props.voucher,         
  props.voucherFlag,     
  props.voucherAuditor,  
  groups,                
  view, edit, cancel
]);


  useEffect(() => {
    if(props.voucherFlag && !props?.voucherAuditor){
      const filteredVariables = variables.filter(item => item.id === props.id);

      filteredVariables.forEach(item => {
        if (item.voucherEquipmentNumber || item.voucherServiceNumber) {
          if (item.voucherServiceNumber && item.voucherServiceStatus !== "CANCELED") setCancelService(true);
        }
      });
      }
    }, [variables, props.id, setCancelService]);


    // Error state
    if (error) {
      return (
          <div className="popover-container">
              <div className="popover-item" style={{ color: 'red', padding: '12px' }}>
                  Failed to load actions
              </div>
          </div>
      );
  }

  // loading state ...
  if (!isReady) {
      return (
          <div id={`action-list-for-${props.id}`} className="popover-container">
              <div className="popover-item" style={{ textAlign: 'center', padding: '12px' }}>
                  <Spin size="small" />
              </div>
          </div>
      );
  }

    const onView = (value) => {
      props.open(false);
      navigateToView(navigate, props.id);
    }

    const onEdit = (value) => {
      dispatch(
        updateFormField({
          group: 'task',
          key: 'processInstanceId',
          value: props.id
            
        })
      ); 
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'viewMode',
          value: false
           
        })
      );
      isBeneficiary(groups) ? dispatch(claimActive(navigate, props.id, null ,"beneficiary")) : dispatch(claimActive(navigate, props.id, null ,"installer"));
    }

    const onEditVoucher = (value) => {

      dispatch(
        updateFormField({
          group: 'task',
          key: 'processInstanceId',
          value: props.id
        })
      ); 

      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'voucher',
          value: props.voucher
        })
      ); 

      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'viewMode',
          value: false 
        })
      );
      
      props?.voucherAuditor ? 
        navigate(`/main-forms/${props.id}/${props.voucher}/${props.supplierVat}`)
      :
        navigate(`/main-forms/${props.id}/${props.voucher}`)

    }

  const onCancel = () => {
      props.open(false)
      props.setCancelModal(true)
  }
  const onAssignService = async (procInstId) => {
    props.open(false)
    try {
      await returnToEvaluation(procInstId);
      props.setRefreshKey((k) => k + 1); 
    } catch (error) {
      console.error("Return failed:", error);
    }
  };

  const onCancelService = () => {
    props.open(false)
    props.setCancelModalService(true)
  }

  const onCancelAccepted = () => {
      props.open(false)
      props.setCancelModalAccepted(true)
  }
  
  const onCancelServiceAccepted = () => {
      props.open(false)
      props.setCancelModalServiceAccepted(true)
  }

  const onUnassignService = () => {
    props.open(false)
    props.setUnassignModalService(true)
  }

  const onReleaseEquipment = () => {
    props.open(false)
    props.setReleaseEquipmentModal(true)
  }

  const onReleaseService = () => {
    props.open(false)
    props.setReleaseServiceModal(true)
  }

  const renderEditLabel = (groups) => {
    if (isAuditor(groups)) {
      return <span>Αξιολόγηση <CheckIcon className="check" /></span>;
    }else if(isObjectionCommittee(groups)){
      return <span>Αξιολόγηση Ένστασης <CheckIcon className="check" /></span>;
    }else {
      return <span>Επεξεργασία <CheckIcon className="check" /></span>;
    }
  };


  return(
        <div id={`action-list-for-${props.id}`} className={(releaseEquipment || releaseService) ? "popover-container-wider" : "popover-container"}>
            { view ? <div id="action-button-view" className="popover-item" onClick={()=>onView(props.id)}>Προβολή <CheckIcon className="check"/></div>: null }
            { edit ? <div id="action-button-edit" className="popover-item" onClick={()=>onEdit(props.id)}>{renderEditLabel(groups)}</div> : null }
            { submitObjection ? <div id="action-button-submitObjection" className="popover-item" onClick={()=>onEdit(props.id)}><span>Ένσταση <CheckIcon className="check"/></span></div> : null }
            { cancel ? <div id="action-button-cancel" className="popover-item" onClick={()=>onCancel(props.id)}><span>Ακύρωση Αίτησης <CheckIcon className="check"/></span></div> : null }
            { (cancel && cancelService && isBeneficiary(groups)) ? <div id="action-button-cancel-service" className="popover-item" onClick={()=>onCancelService(props.id)}><span>Ακύρωση Voucher Υπηρεσιών<CheckIcon className="check"/></span></div> : null }
            
            { (cancelAccepted && isBeneficiary(groups)) ? <div id="action-button-cancel-accepted" className="popover-item" onClick={()=>onCancelAccepted(props.id)}><span>Ακύρωση Αίτησης<CheckIcon className="check"/></span></div> : null }
            { (cancelServiceFromAccepted && isBeneficiary(groups)) ? <div id="action-button-cancel-service-accepted" className="popover-item" onClick={()=>onCancelServiceAccepted(props.id)}><span>Ακύρωση Voucher Υπηρεσιών<CheckIcon className="check"/></span></div> : null }

            { (assign && isBeneficiary(groups)) ? <div id="action-button-assign" className="popover-item" onClick={()=>onAssignService(props.id)}><span>Επαναξιολόγηση Αίτησης<CheckIcon className="check"/></span></div> : null }
            { unassign ? <div id="action-button-unassign" className="popover-item" onClick={()=>onUnassignService(props.id)}><span>Ανάθεση σε άλλον αξιολογητή<CheckIcon className="check"/></span></div> : null }
            { voucherEdit ? (
                            <div
                              id="action-button-submitObjection"
                              className={`popover-item ${!persmissionsTrue ? 'disabled' : ''}`}
                              onClick={() => {
                                if (persmissionsTrue) {
                                  onEditVoucher(props.id);
                                }
                              }}
                            >
                              <span>
                                Επεξεργασία Voucher <CheckIcon className="check" />
                              </span>
                            </div>
                          ) 
              : null}
              { releaseEquipment ? <div id="action-button-releaseEquipment" className="popover-item" onClick={()=>onReleaseEquipment(props?.voucherEquipmentNumber)}><span>Αποδέσμευση Voucher Εξοπλισμού <CheckIcon className="check"/></span></div> : null }
              { releaseService ? <div id="action-button-releaseService" className="popover-item" onClick={()=>onReleaseService(props?.voucherServiceNumber)}><span>Αποδέσμευση Voucher Υπηρεσιών <CheckIcon className="check"/></span></div> : null }
              { props?.voucherAuditor ? <div id="action-button-releaseService" className="popover-item" onClick={()=>onEditVoucher(props.id)}><span>Αξιολόγηση Voucher <CheckIcon className="check"/></span></div> : null }

      </div>
  )
  
}

export default ActionList;